import { MaterialIcon } from '@pelckmans/business-components/components/material-icon';
import useThrowAsyncError from '../../../../hooks/useThrowAsyncError';
import { getFileTypeDescription } from '../../../../utils/fileType';
import { FileUserMaterial, getSignedUrl } from '../../_api/UserMaterialApi';
import { Node } from '../../_api/TableOfContentsApi';
import UserMaterialContentType from '../../_components/common/UserMaterialContentType';
import UserMaterialInfo from '../../_components/common/UserMaterialInfo';
import ImagePreviewModal from '../../_modals/ImagePreviewModal';
import JWPlayerModal from '../../_modals/JWPlayerModal';
import PdfPreviewModal from '../../_modals/PdfPreviewModal';
import PreviewModal from '../../_modals/PreviewModal';

export default function useFileUserMaterial() {
  const handleError = useThrowAsyncError();

  async function openFileUserMaterial(material: FileUserMaterial, node: Node) {
    try {
      const { url, downloadUrl, previewUrl } = await getSignedUrl(material.moduleId, material.id);

      if (previewUrl) {
        return (
          <PdfPreviewModal
            id="pdf-preview-modal"
            url={previewUrl}
            downloadUrl={downloadUrl}
            name={material.name}
            info={<UserMaterialInfo material={material} nodeDescription={node.description} />}
            contentType={<UserMaterialContentType />}
            node={node}
          />
        );
      }

      const fileType = getFileTypeDescription(material.file.mimeType).key;

      switch (fileType) {
        case 'AUDIO':
        case 'VIDEO':
          return (
            <JWPlayerModal
              media={{ file: url }}
              downloadUrl={downloadUrl}
              audioOnly={fileType === 'AUDIO'}
              id={`jwplayer-${fileType.toLocaleLowerCase()}-modal`}
              name={material.name}
              node={node}
              contentType={<UserMaterialContentType />}
            />
          );
        case 'IMAGE':
          return (
            <ImagePreviewModal
              id="image-preview-modal"
              downloadUrl={downloadUrl}
              image={{
                src: url,
                alt: material.name,
              }}
              node={node}
              contentType={<UserMaterialContentType />}
              name={material.name}
              info={<UserMaterialInfo material={material} nodeDescription={node.description} />}
            />
          );
      }

      return (
        <PreviewModal
          id="preview-modal"
          downloadUrl={downloadUrl}
          icon={<MaterialIcon materialType="user-material" />}
          node={node}
          contentType={<UserMaterialContentType />}
          name={material.name}
        >
          <p className="name">{material.name}</p>
          <UserMaterialInfo material={material} nodeDescription={node.description} />
        </PreviewModal>
      );
    } catch (error) {
      handleError(error);
    }
  }

  return { openFileUserMaterial };
}
